import React from 'react'
import MethodMappingRow from './MethodMappingRow'
import { EmptyState, ErrorState, LoadingState } from '../../Components/MappingStates'
import Shared from '../../mappingUi.module.css'
import Style from '../methodMapping.module.css'

const MethodMappingList = ({
    rows,
    idPrefix,
    entityLabel,
    emptyIcon,
    erpMethods,
    ecommerceMethods,
    isLoading,
    loadError,
    isDisabled,
    onChange,
    onRemove
}) => {
    if (isLoading) {
        return <LoadingState message={`Loading ${entityLabel} details...`} />
    }
    if (loadError) {
        return <ErrorState message={loadError} />
    }
    if (rows.length === 0) {
        return (
            <EmptyState
                icon={emptyIcon}
                message={`No ${entityLabel} mappings yet`}
                hint={`Pick an ERP and an eCommerce ${entityLabel} above, then add the pair.`}
            />
        )
    }

    return (
        <>
            <div className={`${Shared.grid} ${Style.grid} ${Shared.listHeader}`}>
                <span>ERP Method</span>
                <span />
                <span>eCommerce Method</span>
                <span>ERP-Ecom</span>
                <span>Ecom-ERP</span>
                <span className={Shared.listHeaderAction}>Action</span>
            </div>
            <ul className={Shared.list}>
                {rows.map((row) => (
                    <MethodMappingRow
                        key={row.rowId}
                        row={row}
                        idPrefix={idPrefix}
                        erpMethods={erpMethods}
                        ecommerceMethods={ecommerceMethods}
                        isDisabled={isDisabled}
                        onChange={onChange}
                        onRemove={onRemove}
                    />
                ))}
            </ul>
        </>
    )
}

export default MethodMappingList
